export default __webpack_public_path__ + "static/media/goal2.b3b0ab45.webp";